import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface CommunityModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoSrc?: string;
  formUrl?: string;
}

const DEFAULT_VIDEO_SRC = "/videos/community-video.mp4";
const DEFAULT_FORM_URL = "https://form.typeform.com/to/dMu6D1On";

const CommunityModal = ({ isOpen, onClose, videoSrc, formUrl }: CommunityModalProps) => {
  const { t } = useTranslation();
  const finalVideoSrc = videoSrc || DEFAULT_VIDEO_SRC;
  const finalFormUrl = formUrl || DEFAULT_FORM_URL;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl w-[95vw] sm:w-full">
        <DialogHeader>
          <DialogTitle className="text-xl sm:text-2xl font-bold text-center">
            {t('community.title')}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="w-full aspect-video bg-black rounded-lg overflow-hidden">
            <video
              src={finalVideoSrc}
              crossOrigin="anonymous"
              controls
              className="w-full h-full object-contain bg-black"
            />
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href={finalFormUrl} target="_blank" rel="noopener noreferrer">
              <Button className="w-full sm:w-auto">{t('community.joinNow')}</Button>
            </a>
            <Button variant="outline" className="w-full sm:w-auto" onClick={onClose}>
              {t('community.close')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CommunityModal;


